import { createContext, useMemo } from 'react';

import type { ConfigContextValue, ConfigProviderProps } from './types';

const ConfigContext = createContext<ConfigContextValue | null>(null);

export default function ConfigProvider(props: Readonly<ConfigProviderProps>) {
  const { config, children } = props;

  const contextValue = useMemo(
    () => ({
      config,
    }),
    [config],
  );

  return <ConfigContext.Provider value={contextValue}>{children}</ConfigContext.Provider>;
}

export { ConfigContext };
